import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState(),
    // { storage: window.sessionStorage } // 默认是 window.localStorage
  ],
  state: {
    token: '',
    menus: '',
    areas: null
  },
  getters: {
    token(state) {
      return state.token
    },
    menus(state) {
      return state.menus
    },
  },
  mutations: {
    // 存储token
    setToken(state, token) {
      state.token = token
    },
    // 删除token
    removeToken(state) {
      state.token = ''
    },
    // 存储菜单
    setMenus(state, menus) {
      state.menus = menus
    },
    // 存储区域
    setareas(state, areas) {
      state.areas = areas
    },
    // 删除token
    removeMenus(state) {
      state.menus = ''
    },
    // 删除区域
    removeareas(state) {
      state.areas = ''
    }
  },
  actions: {},
})
